/**
 *  @class
 *  @function RecentlyViewedProducts
 */

const RecentlyViewedProductCards = (cards) => {
  const resetActiveSibling = (siblings) => {
    siblings.forEach(sibling => {
      sibling.classList.remove('active');
    });
  }

  if (cards.length > 0) {
    cards.forEach(productCard => {
      const productCardTitle = productCard.querySelector('.product-card-info .product-card-title');
      const productCardPrice = productCard.querySelector('.product-card-info .price ins .amount');
      const productCardFeaturedImage = productCard.querySelector('.product-primary-image');
      const productCardSecondImage = productCard.querySelector('.product-secondary-image');
      const productCardImageLink = productCard.querySelector('.product-card--featured-image-link');
      const quickView = productCard.querySelector('.product-card-quickview');

      const siblings = productCard.querySelectorAll('.sibling-item');
        
      productCard.addEventListener('mouseover', (e) => {
        const sibling = e.target.closest('.sibling-item');
        if (sibling && productCard.contains(sibling)) {
          const title = sibling.dataset.siblingTitle;
          const price = sibling.dataset.siblingPrice;
          const featuredImage = sibling.dataset.siblingImage;
          const secondaryImage = sibling.dataset.siblingSecondImage;
          const comparePrice = sibling.dataset.siblingComparePrice;
          const siblingUrl = sibling.href;
          const siblingHandle = sibling.dataset.siblingHandle;

          if(siblings.length > 0) {
            resetActiveSibling(siblings)
          }
          
          sibling.classList.add('active');

          if(productCardImageLink) {
            productCardImageLink.href = siblingUrl;
          }
          
          if(quickView) {
            quickView.dataset.productHandle = siblingHandle;
          }

          if(productCardTitle) {
            productCardTitle.innerText = title;
            productCardTitle.href = siblingUrl;
          }

          if(productCardPrice) {
            productCardPrice.innerText = price;
          }

          if(productCardFeaturedImage) {
            productCardFeaturedImage.src = featuredImage;
            productCardFeaturedImage.dataset.src = featuredImage;
            productCardFeaturedImage.alt = title;
            productCardFeaturedImage.srcset = featuredImage;
          }
          
          if(productCardSecondImage) {
            productCardSecondImage.src = secondaryImage;
            productCardSecondImage.dataset.src = secondaryImage;
            productCardSecondImage.alt = title;
            productCardSecondImage.srcset = secondaryImage;
          }
        }
      });
    });
  }
};

if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 4;
      this.products = '';
      if (window.localStorage) {
        let recentIds = window.localStorage.getItem('recently-viewed');
        if (recentIds && typeof(recentIds) !== undefined) {
          window.recentlyViewedIds = JSON.parse(recentIds);
        }
      }
    }
    connectedCallback() {
      this.buildUrl();
    }
    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });

      this.url = this.url + encodeURIComponent(this.products);

      this.fetchProducts();
    }
    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');

            const recentlyViewedProducts = this.querySelectorAll('.product-card');
            RecentlyViewedProductCards(recentlyViewedProducts);
          }

        })
        .catch(e => {
          console.error(e);
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}